
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { TestTube, Coins } from "lucide-react";

interface OfferedReagent {
  id: string;
  name: string;
  catalogue_number?: string | null;
  amount?: number | null;
  amount_unit?: string | null;
  storage_conditions?: string | null;
  description?: string | null;
}

interface OfferedItemCardProps {
  creditOffer?: number | null;
  offeredReagent?: OfferedReagent | null;
  offeredReagents?: OfferedReagent[];
}

const OfferedItemCard: React.FC<OfferedItemCardProps> = ({ 
  creditOffer, 
  offeredReagent, 
  offeredReagents 
}) => {
  const hasOfferedReagent = offeredReagent || (offeredReagents && offeredReagents.length > 0);
  
  // Get the reagent data from either source
  const reagent = offeredReagent || (offeredReagents && offeredReagents.length > 0 ? offeredReagents[0] : null);
  
  return (
    <div>
      <h3 className="text-lg font-medium mb-3 flex items-center">
        {hasOfferedReagent ? (
          <>
            <TestTube className="h-5 w-5 mr-2 text-reagent-blue" />
            Offered Reagent
          </>
        ) : (
          <>
            <Coins className="h-5 w-5 mr-2 text-amber-500" />
            Credit Offer
          </>
        )}
      </h3>
      
      <Card>
        <CardContent className="pt-6">
          {reagent ? (
            <div className="space-y-3">
              <div>
                <p className="text-sm text-muted-foreground">Name</p>
                <p className="font-medium">{reagent.name}</p>
              </div>
              
              {reagent.catalogue_number && (
                <div>
                  <p className="text-sm text-muted-foreground">Catalog Number</p>
                  <p>{reagent.catalogue_number}</p>
                </div>
              )}
              
              {reagent.amount && reagent.amount_unit && (
                <div>
                  <p className="text-sm text-muted-foreground">Amount</p>
                  <p>{reagent.amount} {reagent.amount_unit}</p>
                </div>
              )}
              
              {reagent.storage_conditions && (
                <div>
                  <p className="text-sm text-muted-foreground">Storage</p>
                  <p>{reagent.storage_conditions}</p>
                </div>
              )}
              
              {reagent.description && (
                <div>
                  <p className="text-sm text-muted-foreground">Description</p>
                  <p>{reagent.description}</p>
                </div>
              )}
            </div>
          ) : (
            <div className="flex items-center justify-center py-8">
              <Coins className="h-8 w-8 text-amber-500 mr-3" />
              <span className="text-2xl font-bold">{creditOffer} credits</span>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default OfferedItemCard;
